import type { VehiclePastAssociationDto } from '@cobliteam/api-lib/src/__generated__/graphql';
import GrahpQLVehicleRequester from '@cobliteam/api-lib/src/dashboard/vehicle/GrahpQLVehicleRequester';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

// Lazy instantiation to avoid circular dependency issues
const getVehicleRequester = () => new GrahpQLVehicleRequester();

const QUERY_KEY = 'VEHICLE_PAST_ASSOCIATIONS';

const useVehiclePastAssociations = (
  { vehicleId, referenceTimestamp }: { vehicleId: string; referenceTimestamp: string },
  options?: Partial<UseQueryOptions<VehiclePastAssociationDto[]>>
) => {
  return useQuery<VehiclePastAssociationDto[]>({
    queryKey: [QUERY_KEY, vehicleId, referenceTimestamp],
    queryFn: () => getVehicleRequester().getVehiclePastAssociations(vehicleId, referenceTimestamp),
    ...options,
  });
};

export default useVehiclePastAssociations;
